const TRACKING_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'gbraid',
  'wbraid',
  'msclkid',
];

export function appendTrackingParams(destinationUrl, currentSearch) {
  try {
    const search = typeof currentSearch === 'string' ? currentSearch : window.location.search;
    const srcParams = new URLSearchParams(search || '');
    if ([...srcParams.keys()].length === 0) return destinationUrl;

    const dest = new URL(destinationUrl, window.location.origin);
    for (const key of TRACKING_KEYS) {
      const value = srcParams.get(key);
      if (value && !dest.searchParams.has(key)) {
        dest.searchParams.set(key, value);
      }
    }
    return dest.toString();
  } catch {
    return destinationUrl;
  }
}

